module.exports = __webpack_public_path__ + "static/media/cancel-button.773b6a0b.svg";